<template>
    <div class="container admin-table-page">
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button
                        class="page-back-btn mr-2"
                        variant="link"
                        @click="goBack"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'arrow-alt-circle-left']"
                            class="back-icon"
                        />
                    </b-button>
                    <h2 class="param-title">
                        {{ labels.title }}
                    </h2>
                </div>
            </div>
        </div>
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <label>
                        {{ labels.fechaIni }}
                    </label>
                    <input
                        type="month"
                        v-model="fechaIni"
                        class="form-control mx-3"
                        :placeholder="labels.fechaIni"
                        style="width: 180px;"
                    >
                    <label>
                        {{ labels.fechaFin }}
                    </label>
                    <input
                        type="month"
                        v-model="fechaFin"
                        class="form-control mx-3"
                        :placeholder="labels.fechaFin"
                        style="width: 180px;"
                    >
                    <b-button
                        class="consult-btn mx-3"
                        @click="consulSaldPorContDesdHast"
                        :disabled="!fechaIni || !fechaFin"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'search']"
                            class="mr-1"
                        />
                        {{ labels.consultar }}
                    </b-button>
                </div>
            </div>
        </div>
        <div class="admin-table-block mt-4">
            <CorporateDataTable
                :items="lstRepSaldContrFechaDesHas"
                :fields="fields"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                :show-search="true"
                :allow-column-toggle="true"
                :enable-sorting="true"
                :filter-defs="tableFilterDefs"
                :toolbar-disabled="false"
            >
                <template #toolbar-actions>
                    <div class="niif-toolbar-right">
                        <b-button
                            size="sm"
                            class="table-toolbar-excel-btn"
                            @click="genReportSaldPorCont"
                            :disabled="lstRepSaldContrFechaDesHas.length === 0"
                            title="Exportar a Excel"
                        >
                            <font-awesome-icon
                                :icon="['fas', 'file-excel']"
                                class="mr-1"
                            />
                        </b-button>
                    </div>
                </template>
                <template #cell()="data">
                    <div
                        :class="{
                            'text-right': isNumeric(data.value),
                            'text-left': !isNumeric(data.value)
                        }"
                    >
                        {{
                            isNumeric(data.value)
                                ? formatNumber(data.value)
                                : data.value
                        }}
                    </div>
                </template>
            </CorporateDataTable>
        </div>
    </div>
</template>


<script>

import Reportes from '../../services/Reportes'
import Authentication from '../../services/Authentication'
import CorporateDataTable from '../utils/CorporateDataTable.vue'
import ExcelJS from 'exceljs'

export default {
    name: 'SaldosPorContratoDesHas',
    components: {
        CorporateDataTable
    },
    data: () => ({
        fechaIni: '',
        fechaFin: '',
        lstRepSaldContrFechaDesHas: [],
        mesesSeleccionados: [],
        fields: [],
        nameCompania: ''
    }),
    computed: {
        labels() {
            if (this.$store.state._language == 'es-ES') {

                return {
                    title: 'Saldos por contrato',
                    consultar: 'Consultar',
                    fechaIni: 'Desde',
                    fechaFin: 'Hasta'
                }

            } else {

                return {
                    title: 'Contract balances',
                    consultar: 'Consult',
                    fechaIni: 'From',
                    fechaFin: 'Until'
                }

            }
        },
        tableLabels() {
            if (this.$store.state._language == 'es-ES') {

                return {
                    search: 'Buscar',
                    noData: 'No hay datos',
                    noResults: 'No se encontraron resultados',
                    perPage: 'Registros por página',
                    columns: 'Columnas'
                }

            } else {

                return {
                    search: 'Search',
                    noData: 'No data',
                    noResults: 'No results found',
                    perPage: 'Rows per page',
                    columns: 'Columns'
                }

            }
        },
        tableFilterDefs() {
            return [
                {
                    key: 'nro_contrato',
                    type: 'text',
                    placeholder: 'Contrato'
                },
                {
                    key: 'arrendador',
                    type: 'text',
                    placeholder: 'Arrendador'
                }
            ]
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        consulSaldPorContDesdHast() {

            if (!this.fechaIni || !this.fechaFin) {

                this.$toast.error(
                    'Diligenciar la fecha.'
                )
                return
            }

            if (this.fechaIni > this.fechaFin) {

                this.$toast.error(
                    'La fecha inicial no puede ser mayor que la fecha final.'
                )

                return
            }

            Reportes
            .generaReportSaldosPorContratFechaDesdHasta(
                this.fechaIni,
                this.fechaFin
            )
            .then((res) => {

                this.lstRepSaldContrFechaDesHas = res.data.lstSaldPorContrFechDesHas || []
                this.generarColumnasTabla()

                if (
                    this.lstRepSaldContrFechaDesHas.length === 0
                ) {

                    this.fields = []
                    this.$toast.error('No hay datos para la fecha.')
                }

            })
            .catch((err) => {
                console.error('Error consultando saldos:', err)
                this.$toast.error('Error consultando la información.')
            })
        },
        generarColumnasTabla() {

            const meses = this.generarMeses(
                this.fechaIni,
                this.fechaFin
            )


            const columnas = [
                {
                    key: 'nro_contrato',
                    label: 'Contrato',
                    sortable: true,
                    thClass: 'text-center text-nowrap',
                    tdClass: 'text-center text-nowrap'
                },
                {
                    key: 'arrendador',
                    label: 'Arrendador',
                    sortable: true,
                    thClass: 'text-center text-nowrap',
                    tdClass: 'text-left text-nowrap'
                }
            ]
            meses.forEach(mes => {

                const sufijo = this.mesToSuffix(mes)


                columnas.push(

                    {
                        key: `activo_derecho_uso_${sufijo}`,
                        label: `Activo ${mes}`,
                        sortable: true,
                        thClass: 'text-center text-nowrap',
                        tdClass: 'text-end text-nowrap'
                    },

                    {
                        key: `pasivo_final_${sufijo}`,
                        label: `Pasivo Final ${mes}`,
                        sortable: true,
                        thClass: 'text-center text-nowrap',
                        tdClass: 'text-end text-nowrap'
                    },

                    {
                        key: `pasivo_inicial_${sufijo}`,
                        label: `Pasivo Inicial ${mes}`,
                        sortable: true,
                        thClass: 'text-center text-nowrap',
                        tdClass: 'text-end text-nowrap'
                    },

                    {
                        key: `pago_capital_${sufijo}`,
                        label: `Pago Capital ${mes}`,
                        sortable: true,
                        thClass: 'text-center text-nowrap',
                        tdClass: 'text-end text-nowrap'
                    },

                    {
                        key: `gasto_por_amortizacion_${sufijo}`,
                        label: `Gasto Amortización ${mes}`,
                        sortable: true,
                        thClass: 'text-center text-nowrap',
                        tdClass: 'text-end text-nowrap'
                    },

                    {
                        key: `gasto_por_intereses_${sufijo}`,
                        label: `Gasto Intereses ${mes}`,
                        sortable: true,
                        thClass: 'text-center text-nowrap',
                        tdClass: 'text-end text-nowrap'
                    },

                    {
                        key: `patrimonio_neto_${sufijo}`,
                        label: `Patrimonio ${mes}`,
                        sortable: true,
                        thClass: 'text-center text-nowrap',
                        tdClass: 'text-end text-nowrap'
                    }

                )

            })

            this.fields = columnas

        },
        isNumeric(value) {

            if (
                value === null ||
                value === undefined ||
                value === ''
            ) {
                return false
            }

            return !isNaN(value) && !isNaN(parseFloat(value))

        },
        async genReportSaldPorCont() {

            this.mesesSeleccionados =
                this.generarMeses(
                    this.fechaIni,
                    this.fechaFin
                )

            const meses =
                this.mesesSeleccionados.map(m => {

                    const [nombreMes, anio] =
                        m.split(' ')

                    const mesNum =
                        new Date(
                            `${nombreMes} 1, ${anio}`
                        ).getMonth() + 1

                    const mesStr =
                        `${anio}-${mesNum
                            .toString()
                            .padStart(2, '0')}`

                    return {
                        key: mesStr,
                        label: m
                    }

                })


            const workbook =
                new ExcelJS.Workbook()


            const worksheet =
                workbook.addWorksheet(
                    'Saldos por contrato'
                )


            worksheet.addRow([
                'Saldos por contrato'
            ])

            worksheet.mergeCells(
                1,
                1,
                1,
                2 + meses.length * 7
            )


            worksheet.getCell('A1').font = {
                name: 'Arial',
                bold: true,
                size: 12
            }

            worksheet.getCell('A1').alignment = {
                horizontal: 'center'
            }
            
            worksheet.addRow([''])

            const totColFilDos =
                2 + meses.length * 7

            worksheet.mergeCells(
                2,
                1,
                2,
                totColFilDos
            )


            const cell2 =
                worksheet.getCell('A2')


            cell2.value = {
                richText: [
                    {
                        text: 'Desde: ',
                        font: { bold: true }
                    },
                    {
                        text: `${this.fechaIni} | `
                    },
                    {
                        text: 'Hasta: ',
                        font: { bold: true }
                    },
                    {
                        text: `${this.fechaFin}`
                    }
                ]
            }


            cell2.font = {
                name: 'Arial',
                size: 12
            }

            cell2.alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }

            worksheet.addRow([''])

            const totColFilTres =
                2 + meses.length * 7

            worksheet.mergeCells(
                3,
                1,
                3,
                totColFilTres
            )


            const cell3 =
                worksheet.getCell('A3')


            cell3.value = {
                richText: [
                    {
                        text: 'Generado por: ',
                        font: { bold: true }
                    },
                    {
                        text: `${this.$store.state.userName} | `
                    },
                    {
                        text: 'Fecha generación: ',
                        font: { bold: true }
                    },
                    {
                        text: `${this.fechaActual()} | `
                    },
                    {
                        text: 'Compañía: ',
                        font: { bold: true }
                    },
                    {
                        text: `${this.nameCompania}`
                    }
                ]
            }


            cell3.font = {
                name: 'Arial',
                size: 12
            }

            cell3.alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }

            worksheet.addRow([''])

            worksheet.mergeCells('A4:H4')

            const tituloCelda = [
                'Contrato',
                'Arrendador'
            ]


            meses.forEach(m => {
                tituloCelda.push(
                    `Activo Derecho Uso ${m.label}`,
                    `Pasivo Final ${m.label}`,
                    `Pasivo Inicial ${m.label}`,
                    `Pago Capital ${m.label}`,
                    `Gasto Por Amortización ${m.label}`,
                    `Gasto Por Intereses ${m.label}`,
                    `Patrimonio Neto ${m.label}`
                )
            })

            const headerRow = worksheet.addRow(tituloCelda)


            headerRow.eachCell(cell => {

                cell.font = {
                    name: 'Arial',
                    size: 12,
                    bold: true
                }

                cell.alignment = {
                    horizontal: 'center',
                    vertical: 'middle'
                }

            })

            this.lstRepSaldContrFechaDesHas
                .forEach(e => {

                    const fila = [
                        e.nro_contrato,
                        e.arrendador
                    ]


                    this.mesesSeleccionados
                        .forEach(mes => {

                            const sufijo = this.mesToSuffix(mes)
                            fila.push(

                                this.formatNumber(
                                    Number(e[`activo_derecho_uso_${sufijo}`])
                                ) || 0,

                                this.formatNumber(
                                    Number(e[`pasivo_final_${sufijo}`])
                                ) || 0,

                                this.formatNumber(
                                    Number(e[`pasivo_inicial_${sufijo}`])
                                ) || 0,

                                this.formatNumber(
                                    Number(e[`pago_capital_${sufijo}`])
                                ) || 0,

                                this.formatNumber(
                                    Number(e[`gasto_por_amortizacion_${sufijo}`])
                                ) || 0,

                                this.formatNumber(
                                    Number(e[`gasto_por_intereses_${sufijo}`])
                                ) || 0,

                                this.formatNumber(
                                    Number(e[`patrimonio_neto_${sufijo}`])
                                ) || 0

                            )

                        })


                    worksheet.addRow(fila)

                })
            const border = {

                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }

            }

            worksheet.eachRow(row => {
                if (row.number <= 4) {
                    return
                }
                row.eachCell(cell => {

                    cell.border = border

                })
            })

            worksheet.columns.forEach(
                column => column.width = 18
            )

            const file =
                await workbook.xlsx.writeBuffer()


            const downloadLink =
                document.createElement('a')


            downloadLink.download =
                'Reporte saldos por contrato.xlsx'


            downloadLink.href =
                window.URL.createObjectURL(
                    new Blob(
                        [file],
                        {
                            type:
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        }
                    )
                )


            downloadLink.click()

        },
        generarMeses(fechaInicio, fechaFin) {

            const meses = []


            let [
                inicioAño,
                inicioMes
            ] =
                fechaInicio
                    .split('-')
                    .map(Number)


            let [
                finAño,
                finMes
            ] =
                fechaFin
                    .split('-')
                    .map(Number)


            let current =
                new Date(
                    inicioAño,
                    inicioMes - 1
                )


            const fin =
                new Date(
                    finAño,
                    finMes - 1
                )


            while (current <= fin) {

                const nombreMes =
                    current.toLocaleString(
                        'es-CO',
                        {
                            month: 'long'
                        }
                    )


                const año =
                    current.getFullYear()


                const nombreFormateado =
                    nombreMes.charAt(0).toUpperCase() +
                    nombreMes.slice(1)


                meses.push(
                    `${nombreFormateado} ${año}`
                )


                current.setMonth(
                    current.getMonth() + 1
                )

            }


            return meses

        },
        mesToSuffix(mes) {
            return mes
                .toLowerCase()
                .replace(' ', '_')
        },
        formatNumber(value) {

            return new Intl.NumberFormat(
                'es-CO',
                {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }
            ).format(value)

        },
        fechaActual() {

            const fecha = new Date()

            const año =
                fecha.getFullYear()

            const mes =
                String(
                    fecha.getMonth() + 1
                ).padStart(2, '0')

            const dia =
                String(
                    fecha.getDate()
                ).padStart(2, '0')


            return `${año}-${mes}-${dia}`

        }

    },
    mounted() {

        Authentication.leaParametros()
        .then(result => {
            this.nameCompania = result.data.parametros.compania
        })
        .catch(err =>
            console.log(err)
        )
    }

}

</script>

<style src="../main.css">
</style>
<style scoped>
.table-toolbar-excel-btn {
    height: 31px;
    min-height: 31px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 13px;
    background-color: #016690;
    color: white;
    border: 1px solid #085170;
}

.table-toolbar-excel-btn:hover:not(:disabled) {
    background-color: #085170;
    border-color: #0e3a4d;
}

.table-toolbar-excel-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}
</style>